/**
 * @generated SignedSource<<e89d9e261655b0c1fe359f2c906945d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarryForward_MoreActionsMenu_note$data = {
  readonly id: string;
  readonly previousNote: {
    readonly pendingAgendaCount: number;
    readonly pendingTodoCount: number;
  } | null;
  readonly " $fragmentType": "CarryForward_MoreActionsMenu_note";
};
export type CarryForward_MoreActionsMenu_note$key = {
  readonly " $data"?: CarryForward_MoreActionsMenu_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarryForward_MoreActionsMenu_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarryForward_MoreActionsMenu_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingAgendaCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingTodoCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "7f7c44f1a545ac677e1d4bb64216d01b";

export default node;
